import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';

import * as auth from '../app/modules/Auth/_redux/authRedux';

import { ordersSlice } from './../app/modules/Purchase/_redux/orders/ordersSlice';
import { boxesSlice } from './../app/modules/Purchase/_redux/boxes/boxesSlice';
import { productsSlice } from './../app/modules/Products/_redux/products/productsSlice';
import { stocksSlice } from './../app/modules/Stocks/_redux/stocks/stocksSlice';
import { salesSlice } from './../app/modules/Sales/_redux/sales/salesSlice';
import { deliveriesSlice } from './../app/modules/Deliver/_redux/deliveries/deliveriesSlice';
import { usersSlice } from './../app/modules/MerchantUser/_redux/usersSlice';
import { userSlice } from './../app/modules/UserProfile/_redux/slice';
//import {customersSlice} from "../app/modules/ECommerce/_redux/customers/customersSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  users: usersSlice.reducer,
  orders: ordersSlice.reducer,
  boxes: boxesSlice.reducer,
  products: productsSlice.reducer,
  stocks: stocksSlice.reducer,
  sales: salesSlice.reducer,
  deliveries: deliveriesSlice.reducer,
  userInfo: userSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
